import { ICON_COLOR, White } from '@zep-us/zus/tokens';
import { BookCoverIcon } from '@/icons';
import { Chip, Tooltip } from '@/ui_v3';
import { type AchievementStandard } from '../../../ai-quiz-generation/hooks/types';
import { Indicator } from './Indicator';
export const TopSlotWithStandards = ({
  standards,
  isSaved,
  isSelected,
  onDelete
}: {
  standards: AchievementStandard[];
  isSaved: boolean;
  isSelected: boolean;
  onDelete?: () => void;
}) => {
  if (standards.length === 0) return <></>;
  return <div className="flex justify-between" data-sentry-component="TopSlotWithStandards" data-sentry-source-file="TopSlotWithStandard.tsx">
      <div className="flex gap-2xs">
        {standards.map(standard => <StandardChip key={standard.code} standard={standard} />)}
      </div>
      <Indicator isSaved={isSaved} isSelected={isSelected} onDelete={onDelete} data-sentry-element="Indicator" data-sentry-source-file="TopSlotWithStandard.tsx" />
    </div>;
};
export const StandardChip = ({
  standard
}: {
  standard: AchievementStandard;
}) => {
  return <Tooltip.Provider data-sentry-element="unknown" data-sentry-component="StandardChip" data-sentry-source-file="TopSlotWithStandard.tsx">
      <Tooltip.Root data-sentry-element="unknown" data-sentry-source-file="TopSlotWithStandard.tsx">
        <Tooltip.Trigger asChild data-sentry-element="unknown" data-sentry-source-file="TopSlotWithStandard.tsx">
          <Chip leftSlot={<BookCoverIcon width={12} height={12} fill={ICON_COLOR.strong} />} size="sm" className="border border-violet-100 bg-violet-50 text-strong hover:bg-violet-100" data-sentry-element="Chip" data-sentry-source-file="TopSlotWithStandard.tsx">
            {standard.code}
          </Chip>
        </Tooltip.Trigger>
        <Tooltip.Content side="bottom" align="center" alignOffset={-10} className="z-[100000] max-w-[300px] bg-default text-body-sm-semibold text-default" data-sentry-element="unknown" data-sentry-source-file="TopSlotWithStandard.tsx">
          <Tooltip.Arrow style={{
          fill: White
        }} data-sentry-element="unknown" data-sentry-source-file="TopSlotWithStandard.tsx" />
          {`[${standard.code}] ${standard.standard}`}
        </Tooltip.Content>
      </Tooltip.Root>
    </Tooltip.Provider>;
};